module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_function-to-string.js
// module id = 651
// module chunks = 48 49 50 51